import { PaymentMethodTypeEnumDto, DigitalWalletTypeEnumDto } from './api/CoreWebApi';

export enum PaymentMethodTypeEnum {
    CreditCard = 'Credit Card',
    ECheck = 'ECheck',
    Undetermined = 'Undetermined'
}

/** Minimal wallet-discriminator shape — anything carrying type + digitalWalletType. */
export interface WalletDiscriminator {
    type?: PaymentMethodTypeEnum;
    digitalWalletType?: DigitalWalletTypeEnumDto;
}

/** True when the method is a Google Pay wallet (credit-rail + GooglePay tag). */
export function isGooglePay(method: WalletDiscriminator | null | undefined): boolean {
    return method?.type === PaymentMethodTypeEnum.CreditCard
        && method?.digitalWalletType === DigitalWalletTypeEnumDto.GooglePay;
}

/** True when the method is an Apple Pay wallet. */
export function isApplePay(method: WalletDiscriminator | null | undefined): boolean {
    return method?.type === PaymentMethodTypeEnum.CreditCard
        && method?.digitalWalletType === DigitalWalletTypeEnumDto.ApplePay;
}

/** True when the method is any wallet flavor (Google Pay or Apple Pay). */
export function isWallet(method: WalletDiscriminator | null | undefined): boolean {
    return method?.type === PaymentMethodTypeEnum.CreditCard && method?.digitalWalletType != null;
}

export class PaymentMethodTypeEnumConvertor {
    // Accepts a plain string so any generated client's PaymentMethodTypeEnumDto
    // (PublicPortal, Admin, PaymentIntegration, Core) can be converted.
    static fromDto(dto: string): PaymentMethodTypeEnum {
        return PaymentMethodTypeEnum[dto as keyof typeof PaymentMethodTypeEnum];
    }

    static toDto(e: PaymentMethodTypeEnum): PaymentMethodTypeEnumDto {
        let dto: PaymentMethodTypeEnumDto;

        switch (e) {
            case PaymentMethodTypeEnum.CreditCard:
                dto = PaymentMethodTypeEnumDto.CreditCard;
                break;
            case PaymentMethodTypeEnum.ECheck:
                dto = PaymentMethodTypeEnumDto.ECheck;
                break;
            case PaymentMethodTypeEnum.Undetermined:
                dto = PaymentMethodTypeEnumDto.Undetermined;
                break;
            default:
                break;
        }

        return dto;
    }
}
